import styled from 'styled-components';
import { CardButtonMixin } from '../../mixins/components/CardButtonMixin';

/**
 * @since 4.1.0
 */

var CardButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "CardButton",
  componentId: "c11n-8-111-1__sc-ekym3u-0"
})(["", ""], CardButtonMixin);
CardButton.displayName = 'CardButton';

/** @component */
export { CardButton };